import React, { useEffect, useState } from 'react'

function ItemCategoria(props) {
    const {categoria,collback} = props;
    const [editar,setEditar] = useState(false);
    const [nombre,setNombre] = useState('');
    function sendCambio(tipo){
        if(tipo=='G'){
            var info = categoria;
            info.NOMBRE = nombre;
            collback(info);
        }else{
            var info=categoria;
            info.ESTADO='E';
            collback(info);
        }
    }
    useEffect(()=>{
        if(nombre==''){
            setNombre(categoria.NOMBRE);
        }
    },[])
    return (
        <tr>
            <th className='col-4'>
                {editar==false&&<div className='w-100'>{categoria.NOMBRE}</div>}
                {editar&&<input type="text" className="form-control" 
                    placeholder="Nombre Categoria"
                    value={nombre} onChange={(e)=>setNombre(e.target.value.toUpperCase())}></input>}
                <span className='text-light' style={{fontSize:'10px'}}>{'Area: '+(categoria.AREA==null?'NINGUNO':categoria.AREA)}</span>
            </th>
            <td className='text-end'>
                <div className='container-fluid'>
                    <div className='btn-group'>
                        {editar==false&&<button className='btn btn-light' text="Editar Categoria" onClick={()=>setEditar(true)}><i className="fa-solid fa-pen-to-square fa-xl"></i></button>}
                        {editar&&<button className='btn btn-success' text="Guardar Categoria" onClick={()=>sendCambio('G')}><i className="fa-solid fa-floppy-disk fa-xl"></i></button>}
                        <button className='btn btn-danger' text="Eliminar Categoria" onClick={()=>sendCambio('E')}><i className="fa-solid fa-trash-can fa-xl"></i></button>
                    </div>
                </div>
            </td>
        </tr>
    )
}

export default ItemCategoria